export default "__VITE_ASSET__DBg2V_kr__"